import React from 'react';
import _ from 'lodash';

import {
  OrderPropertyName,
  useOrderPropertySelectFieldQuery
} from 'generated/graphql';



export interface IOrderProperty {
  id: OrderPropertyName;
  displayName: string;
}

export interface IData {
  objects: IOrderProperty[];
}

export function useQuery() {
  const queryTuple = useOrderPropertySelectFieldQuery();

  const wrappedTuple = React.useMemo(() => {
    const data: IData = {
      objects: _.map(queryTuple.data?.orderProperties ?? [], (node): IOrderProperty => ({
        id: node.name,
        displayName: node.displayName
      }))
    };

    return {
      loading: queryTuple.loading,
      data,
      refetch: async () => {
        queryTuple.refetch({});
      }
    };
  }, [queryTuple]);

  return wrappedTuple;
}
